import { render, staticRenderFns } from "./responsiblePersonsTable.vue?vue&type=template&id=f72192bc&scoped=true"
import script from "./responsiblePersonsTable.vue?vue&type=script&lang=js"
export * from "./responsiblePersonsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f72192bc",
  null
  
)

export default component.exports